import { render, staticRenderFns } from "./DefaultLayoutLogin.vue?vue&type=template&id=74b228c6&scoped=true&"
import script from "./DefaultLayoutLogin.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutLogin.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayout.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./DefaultLayoutLogin.vue?vue&type=style&index=1&id=74b228c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b228c6",
  null
  
)

export default component.exports